<template>
  <a-descriptions bordered size="small" :column="2">
    <a-descriptions-item>
      <div slot="label" class="center">发起人</div>
      <div class="">
        {{ detail.extra.applicant }}
      </div>
    </a-descriptions-item>

    <a-descriptions-item :span="1">
      <div slot="label" class="center">发起部门</div>
      <div class="">
        {{ detail.extra.applicantDeptName }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">处置说明</div>
      <div class="">
        {{ detail.extra.description }}
      </div>
    </a-descriptions-item>
  </a-descriptions>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
    list() {
      return this.detail.extra?this.detail.extra.fixedAsset : {};
    },
  },
  methods: {
    handleDateChange(date) {
      this.list.postingDate = moment(date).format("YYYY-MM-DD");
    },
  }
};
</script>

